import styles from "./accordion.module.scss";
import { ReactComponent as Arrow } from "../../assets/arrow.svg";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

interface AccordionProps {
  title: string;
  children?: React.ReactNode;
}

const Accordion = ({ title, children }: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className={`${styles.details} ${isOpen ? styles.open : ""}`}>
      <div className={styles.summary} onClick={toggleAccordion}>
        <p>{title}</p>

        <motion.span
          className={styles.arrow}
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
        >
          <Arrow />
        </motion.span>
      </div>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            className={styles.content}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Accordion;
